import { Button } from '@bancobarigui/barihaus';
import { Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined, LinkOutlined } from '@ant-design/icons';
import * as styles from '../styles';

interface AmostraActionsProps {
  isAvaliando: boolean;
  urlOriginal?: string;
  onEdit: () => void;
  onDelete: () => void;
}

export function AmostraActions({ isAvaliando, urlOriginal, onEdit, onDelete }: AmostraActionsProps) {
  return (
    <div style={styles.actionsContainerStyle}>
      {urlOriginal && (
        <Tooltip title="Abrir anúncio em nova aba">
          <Button
            type="text"
            icon={<LinkOutlined />}
            href={urlOriginal}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >{' '}</Button>
        </Tooltip>
      )}
      <Button type="text" icon={<EditOutlined />} onClick={onEdit} style={styles.editButtonStyle}>{' '}</Button>
      {!isAvaliando && (
        <Button type="text" danger icon={<DeleteOutlined />} onClick={onDelete}>{' '}</Button>
      )}
    </div>
  );
}
